"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const TubeCylinderIcon = props => _react.default.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none"
}, props), _react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 5C9.99875 4.95006 9.99873 4.94959 9.9987 4.94911C9.99954 4.96575 10 4.98335 10 5V7.34941L14 7.77223V5C14 4.98335 14.0004 4.9667 14.0012 4.95007C14.0013 4.95054 14.0089 4.95044 14.9997 4.99998L14.0012 4.95007L14.0013 4.94812L14.0015 4.94597L14.0017 4.94111L14.0025 4.92908C14.0031 4.92006 14.0039 4.90904 14.0049 4.89614C14.007 4.87038 14.0102 4.83698 14.0149 4.79702C14.0243 4.71738 14.04 4.60992 14.0663 4.48355C14.1181 4.23518 14.2155 3.89069 14.4021 3.53517C14.798 2.78106 15.6007 2 17 2V4C16.4993 4 16.302 4.21894 16.1729 4.46483C16.097 4.60931 16.0507 4.76482 16.0243 4.89145C16.0116 4.95258 16.0046 5.00137 16.0011 5.03111L16 5.04112V18C16 20.2123 14.2123 22 12 22C9.78772 22 8 20.2123 8 18V5.04113L7.99887 5.03111C7.99536 5.00137 7.98844 4.95258 7.97571 4.89145C7.94933 4.76482 7.90295 4.60931 7.8271 4.46483C7.69801 4.21894 7.5007 4 7 4V2C8.3993 2 9.20199 2.78106 9.5979 3.53517C9.78455 3.89069 9.88192 4.23518 9.93367 4.48355C9.96 4.60992 9.97573 4.71738 9.98512 4.79702C9.98983 4.83698 9.99299 4.87038 9.9951 4.89614L9.99753 4.92908L9.99827 4.94111L9.99854 4.94597L9.9987 4.94911L9 5ZM14 9.28058L10 8.85776V18C10 19.1077 10.8923 20 12 20C13.1077 20 14 19.1077 14 18V9.28058Z",
  fill: "currentColor"
}));

var _default = TubeCylinderIcon;
exports.default = _default;